import { Box, Button, Grid } from '@mui/material'
import React from 'react'
import MaterialTypography from '../../../../../components/MaterialTypography'
import MaterialButton from '../../../../../components/MaterialButton'
import MaterialSelect from '../../../../../components/MaterialSelect'

const Navbar = () => {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#ffffff',
            padding: 1,
            border: '1px solid #e0e0e0',
        }}>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 5, md: 5 }}>
                    <MaterialTypography varint="caption" color="dark" fontWeight="bold">Test Creation</MaterialTypography>
                </Grid>
                <Grid size={{ xs: 12, sm: 7, md: 7 }}>
                    <Grid container spacing={2} justifyContent="flex-end" alignItems="center">
                        {/* <Grid size={{ xs: 12, sm: 5, md: 5 }}>
                            <MaterialSelect
                                label="Filter by"
                                options={['All', 'Passed', 'Failed']}
                                defaultValue="All"
                                size="small"
                            />
                        </Grid> */}
                        {/* <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                            <MaterialButton variant="contained" color="dark" size="small">Add Test Case</MaterialButton>
                        </Grid> */}

                    </Grid>
                </Grid>
            </Grid>
        </Box>
    )
}

export default Navbar
